import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main(props) {
    
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const InternsApprentice = 

    [
        {
            AdvertisementDate: <> 14.10.2024 </>,
            NameofthePost: "Library Information Assistant - Interns (04 Positions)",
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTLIB-INTERNAdvt.2024-2501_Notification_Library_Information_Assistant_Interns.pdf",
                Text: "Notification for the position of Library Information Assistant - Interns for Central Library",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://docs.google.com/forms/d/e/1FAIpQLSenRZrFqoIJObPiEgNndFDLmbtpIFFvccMtxw_qgsYxSx3lrA/viewform",
                    Text: "Online application is closed",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.10.2024 <br /><br />Tentative date of selection process : 20.11.2024</>,
            Status: {
                Link: "#",
                Text: "Will be updated soon",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "yes"
            }
        },

   
        {
            AdvertisementDate: <> 31.10.2023 </>,
            NameofthePost: "Library Information Assistant - Interns (05 Positions)",
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTPLIBINTERNAdvt.2023-2401.pdf",
                Text: "Notification for the position of Library Information Assistant - Interns for Central Library",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 15.11.2023 <br /><br />Tentative date of selection process : 29.11.2023</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements//2023/IITTPLIBINTERNAdvt%202023-2401_Result.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTPLIBInterns2023-2404_Short%20listed_LIA_Interns_2023.pdf",
                Text: "Provisionally Shortlisted and Not Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 01.09.2023 </>,
            NameofthePost: <>Graduate Apprentice (09 Positions)<br/><br/>Technician (Diploma Apprentice) (07 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship/Advt.%20No.%20IITTPAPPRENTICESHIP202301_Apprenticeship_Advertisement.pdf",
                Text: "Advertisement for 1-year Apprenticeship Training Programme for Graduate/Diploma under NATS",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship/Apprenticeship%20Annexure-A.pdf",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : Extended till 03.10.2023</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements//2023/Apprenticeship_Selection_Result.pdf",
                Text: <>Selected Candidates List<br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship%20shortlisted%20&%20Not%20shortlisted%20Candiates.pdf",
                Text: "Provisionally Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        }
          

        

    ]


   
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Interns and Apprentice" />
            <section className="project-detail">
                <div className="container">
                    <div className="c-heading">
                        <h1>Internship and Apprenticeship</h1>
                    </div>

                    <Row>
                        <div className="card-body">

                                {/* <p className="glowing-text">
                                    <b>Update: </b>
                                    <b style={{ color: "blue" }}>
                                    A "Post Serial Number" has been allotted to every applicant against their Application Number. Please log in to the application portal to find your "Post Serial Number." All communication will be made using your Post Serial Number only. Further, please download the application (PDF format) for future correspondence.
                                    </b>
                                </p>
                                
                                <p>Please find the Portal Link:{" "}
                                    <Link
                                        to="https://iittp.plumerp.co.in/prod/iittirupati/staffrecruitment"
                                        target="_blank">
                                        <b className="c-link">Click here</b>
                                    </Link>
                                </p>
                                <p>
                                    <b>
                                        Please find the below table for the syllabus and updates:
                                    </b>
                                </p> */}
                                    <Table bordered responsive className="mt-3 table table-striped">
                                    <thead>
                                        <tr className='c-tablehead'>
                                        <th>
                                        Date
                                            </th>
                                            <th>
                                                Name of the Post
                                            </th>
                                            <th>Advertisement</th>
                                            <th>
                                                Application
                                            </th>
                                            <th>
                                                Last Date
                                            </th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        {InternsApprentice.map((item, index) => (
                                            <tr key={index}>
                                                 <td>{item.AdvertisementDate}</td>
                                                <td>{item.NameofthePost}</td>
                                                <td>
                                                    {typeof item.Advertisement === 'string' ? item.Advertisement : (
                                                        <a href={item.Advertisement.Link} style={{ color: (item.Advertisement.Style && item.Advertisement.Style.color) }} target="_blank" >
                                                            {item.Advertisement.Text}
                                                        </a>
                                                    )}
                                                </td>
                                                <td>
                                                    {item.Application.map((status, i) => (
                                                        <div key={i}>
                                                            <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} target="_blank" >{status.Text}</a>
                                                        </div>
                                                    ))}
                                                </td>
                                                <td>{item.LastDate}</td>
                                                <td>
                                                    {Array.isArray(item.Status) ? (
                                                        item.Status.map((status, idx) => (
                                                            <div key={idx}>
                                                                <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} style={{ color: (status.color || (status.Style && status.Style.color)) }} target="_blank" >
                                                                {status.Text}
                                                                </a>
                                                            </div>
                                                        ))
                                                    ) : (
                                                            <a className={`text-marron ${item.Status.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Status.Link} style={{ color: (item.Status.Style && item.Status.Style.color) }} target="_blank" >
                                                            {item.Status.Text}
                                                        </a>
                                                    )
                                                    
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                            
                                    </Table>     
                        </div>
   
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
